import { render, staticRenderFns } from "./PanelClient.vue?vue&type=template&id=0d4a6865&"
import script from "./PanelClient.vue?vue&type=script&lang=js&"
export * from "./PanelClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports